<template>
  <div>
      <h2>Forgot Password</h2>
      <div v-if="showUserName">
        Please enter your username
      </div>
      <div v-if="showSubmitted">
          An email has been sent to your email on record.<br>
          Please enter the confirmation code from the email and a new password.
      </div>
      <div class="formcontainer">
        <b-form-input v-model='form.username' v-if="showUserName" class='input' placeholder="username"/>
        <b-form-input v-model='form.confirmCode' v-if="showSubmitted" class='input' placeholder="Confirmation code"/>
        <b-form-input v-model='form.password' v-if="showSubmitted" type="password" class='input' placeholder="new password" :state="passwordMatch"/>
        <b-form-input v-model='form.passwordConf' v-if="showSubmitted" type="password" class='input' placeholder="confirm new password" :state="passwordMatch"/>
        <button v-on:click='forgotPassword' v-if='showUserName' class='button'>
          <span v-if="submitting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Forgot Password
        </button>
        <button v-on:click='changePassword' v-if='showSubmitted' class='button'>
          <span v-if="submitting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Change Password
        </button>

      </div>
</div>
</template>

<script>
import { Auth } from 'aws-amplify'; 
export default {
    name: 'ForgotPassword',
    props: ['signIn'],
    data() {
        return {
            form: {
                username: '',
                confirmCode: null,
                password: '',
                passwordConf: ''
            },
            state: 'username',
            submitting: false,
        }
    },
    methods: {
        async forgotPassword() {
            try {
                this.submitting = true;
                await Auth.forgotPassword(this.form.username);
                this.state = 'submitted'
            } catch(err) {
                console.log(err)
            }
            this.submitting = false;
        },
        async changePassword() {
            if(!this.valid)
                return;
            try {
                this.submitting = true;
                await Auth.forgotPasswordSubmit(this.form.username, this.form.confirmCode, this.form.password)
                this.state = 'username'
                this.signIn()
            } catch(err) {
                console.log(err)
            }
            this.submitting = false;
        }
    },
    computed: {
        showUserName() {
            return this.state == 'username'
        },
        showSubmitted() {
            return this.state == 'submitted'
        },

        passwordMatch() {
            if( this.form.password == '')
                return null
            else
                return this.form.password == this.form.passwordConf
        },

        validUsername() {
            if( this.form.username == '' )
                return null;
            else {
                let re = /^[a-zA-Z0-9]+$/
                return re.test(this.form.username)
            }
        },

        valid() {
            return this.passwordMatch && this.validUsername
        }         
    }
    
}
</script>

<style>
.formcontainer {
  display: flex;
  flex-direction: column;
  width: 500px;
  margin: 0 auto;
}
.input {
  margin-bottom: 7px;
  height: 38px;
  border: none;
  outline: none;
  border-bottom: 2px solid #ddd;
  font-size: 20px;
}
.button {
  height: 45px;
  border: none;
  outline: none;
  background-color: #dddddd;
  margin-top: 8px;
  cursor: pointer;
  font-size: 18px;
}
.button:hover {
  opacity: .7
}
</style>